<template>
  <div class="p-1 border border-secondary-60 rounded-xl my-3 flex gap-2 flex-col">
    <router-link
      to=""
      tag="li"
      class="sidebar__item"
      v-if="isTeamVisible
        && isCasualUserNotHaveTeam"
      @click.native="clickCreateNewTeam"
    >
      <aha-icon name="plus" />
      <span
        class="sidebar__item-name"
      >{{ $i18nPresenter.t('Add team member') }}</span>
    </router-link>
    <span
      v-if="isTeamVisible && !isCasualUserNotHaveTeam"
      class="sidebar__item --information truncate overflow-hidden gap-2"
    >
      <span class="truncate">{{ currentAccount.name }}</span>
      <span v-if="isShowFreePlanBadge" class="flex items-center">
        <span class="info-badge">Free</span>
      </span>
    </span>
    <router-link
      to="/apps/team/members"
      tag="li"
      class="sidebar__item has-team pr-0"
      active-class="sidebar__item--active"
      @click.native="clickTeamMembers"
      v-if="isTeamVisible
        && !isCasualUserNotHaveTeam"
    >
      <span class="flex items-center gap-2 mr-2">
        <aha-icon name="users-v2" />
        {{ `${$i18nPresenter.t('Members')} (${currentAccount.numberOfMembers})` }}
      </span>
    </router-link>

    <router-link
      v-if="isTeamVisible && !isCasualUserNotHaveTeam && canUseAdminAnalytics"
      to="/apps/admin-analytics"
      tag="li"
      active-class="sidebar__item--active"
      class="sidebar__item pr-0"
    >
      <aha-icon name="analytical-v2" maintain-color />
      <span
        class="sidebar__item-name"
      >
        {{ $i18nPresenter.t('Analytics') }}
      </span>
    </router-link>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'TeamSideBar',
  props: {
    isCasualUserNotHaveTeam: {
      type: Boolean,
      default: false,
    },
    isTeamVisible: {
      type: Boolean,
      default: false,
    },
    isShowFreePlanBadge: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['clickTeamMembers', 'clickCreateNewTeam'],
  computed: {
    ...mapGetters('featureToggles', ['canUseAdminAnalytics']),
    ...mapState({
      currentAccount: (state) => state.currentAccount,
    }),
  },
  methods: {
    clickTeamMembers() {
      this.$emit('clickTeamMembers')
    },
    clickCreateNewTeam() {
      this.$emit('clickCreateNewTeam')
    },
  },
}
</script>

<style scoped>
.sidebar__item {
  justify-content: start;
}
</style>
